import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const brandsService = {
    get,
    addOrUpdateBrand,
    deleteBrand,
    getAll,
    uploadLogo,
};

function get(page, pageSize) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands?returnAll=true`, requestOptions).then(handleResponse);
}

function addOrUpdateBrand(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/brands`, requestOptions).then(handleResponse);
}

function deleteBrand(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands/${id}`, requestOptions).then(handleResponse);
}

function uploadLogo(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
        },
        body: data,
    };

    return fetch(`${BASE_URL}api/locations/brands/upload-logo`, requestOptions).then(handleResponse);
}
